import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import MultiSelect from "../../ui/multiselect";

const TramiteModal = ({
  tramite,
  categories,
  states,
  onSave,
  onClose,
  editting,
}) => {
  const [formData, setFormData] = useState({
    name: tramite?.name || "",
    description: tramite?.description || "",
    price_type: tramite?.price_type || "fijo",
    fixed_price: tramite?.fixed_price || 0,
    estimated_time_days: tramite?.estimated_time_days || 1,
    required_documents: tramite?.required_documents?.join("\n") || "",
    category_id: tramite?.category_id || "",
    client: tramite?.client_id || {},
    gestor: tramite?.assigned_gestor_id || {},
    states: tramite?.states || [],
  });

  const [edit, setEdit] = useState(false);
  const [saving, setSaving] = useState(false);
  const [selectedStates, setSelectedStates] = useState([]);

  useEffect(() => {
    setEdit(editting);
  }, [editting]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      success("El nombre del trámite es requerido");
      return;
    }

    if (!formData.category_id) {
      success("Selecciona una categoría");
      return;
    }

    setSaving(true);
    try {
      const createData = {
        ...formData,
        required_documents: formData.required_documents
          .split("\n")
          .filter((doc) => doc.trim()),
      };

      if (edit) {
        createData.id = tramite._id;
      }

      await onSave(createData);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1200]">
      <div className="bg-white rounded-lg max-w-2xl w-full mx-4 max-h-[600px] overflow-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h3 className="text-xl font-bold text-gray-900">
              {edit ? "Editar Trámite" : "Crear Nuevo Trámite"}
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl"
            >
              <X />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="grid grid-cols-1">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nombre del Trámite *
              </label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Ej: Avalúo Catastral"
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Categoría *
              </label>
              <select
                value={formData.category_id}
                onChange={(e) =>
                  setFormData({ ...formData, category_id: e.target.value })
                }
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              >
                <option value="">Selecciona categoría...</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.icon} {cat.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Estados
              </label>

              <MultiSelect
                options={states}
                value={formData.states}
                onChange={(val) => setFormData({ ...formData, states: val })}
                labelKey="name"
                valueKey="_id"
                placeholder="Seleccionar estados"
              />

              <p className="text-xs text-gray-500 mt-1">
                Si no seleccionas ninguno, aplica a todos los estados
              </p>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Descripción
            </label>
            <textarea
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent h-24"
              placeholder="Describe los servicios incluidos en este trámite..."
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tipo de Precio
              </label>
              <select
                value={formData.price_type}
                onChange={(e) =>
                  setFormData({ ...formData, price_type: e.target.value })
                }
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="fijo">Precio Fijo</option>
                <option value="variable">Precio Variable</option>
              </select>
            </div>

            {formData.price_type === "fijo" && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Precio Fijo (MXN)
                </label>
                <input
                  type="number"
                  value={formData.fixed_price}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      fixed_price: parseFloat(e.target.value) || 0,
                    })
                  }
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  min="0"
                  step="0.01"
                  placeholder="2500.00"
                />
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tiempo Estimado (días)
              </label>
              <input
                type="number"
                value={formData.estimated_time_days}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    estimated_time_days: parseInt(e.target.value) || 1,
                  })
                }
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                min="1"
                max="365"
                placeholder="15"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Documentos Requeridos (uno por línea)
            </label>
            <textarea
              value={formData.required_documents}
              onChange={(e) =>
                setFormData({ ...formData, required_documents: e.target.value })
              }
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent h-32"
              placeholder="Escritura pública del inmueble&#10;Identificación oficial vigente&#10;Comprobante de domicilio"
            />
            <p className="text-xs text-gray-500 mt-1">
              Escribe cada documento en una línea separada
            </p>
          </div>

          <div className="flex justify-end space-x-3 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              disabled={saving}
              className="px-6 py-3 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={saving || !formData.name.trim()}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {saving ? "Guardando..." : "Actualizar Trámite"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TramiteModal;
